// extracted by mini-css-extract-plugin
export default {"languageSelection":"Language_languageSelection__B3H9m","bodyText":"Language_bodyText__glrUY"};